/**
 * Anatomy ("Acts API") Integration Services
 * CCMS as a client of the external Anatomy platform: person lookup, follow-ups, meetings.
 */
export { AnatomyService } from './AnatomyService';
export { AnatomySettingsService } from './AnatomySettingsService';
import { AnatomyService } from './AnatomyService';
import { AnatomySettingsService } from './AnatomySettingsService';
export function createAnatomyServices(http, config) {
    return {
        anatomy: new AnatomyService(http, config),
        settings: new AnatomySettingsService(http, config),
    };
}
//# sourceMappingURL=index.js.map